import { render, staticRenderFns } from "./PositiveRes.vue?vue&type=template&id=3745159e&"
import script from "./PositiveRes.vue?vue&type=script&lang=js&"
export * from "./PositiveRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports